#import "../fragments/custom-field-fragment.graphql"

query GetCustomFields($input: CustomFieldsInput!) {
    customFields(input: $input) {
        active {
            ...CustomFieldFragment
        }
        archived {
            ...CustomFieldFragment
        }
    }
}
